module.exports = __webpack_public_path__ + "static/media/google_podcasts.2c115190.svg";